import { ERROR_LEVELS, RESPONSE_STATUS } from '@repo/constants';
import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

export const getSentryLevel = (statusCode: number) => {
  switch (statusCode) {
    case RESPONSE_STATUS.BAD_REQUEST:
      return ERROR_LEVELS.ERROR;
    case RESPONSE_STATUS.NOT_FOUND:
      return ERROR_LEVELS.INFO;
    case RESPONSE_STATUS.INTERNAL_SERVER_ERROR:
      return ERROR_LEVELS.FATAL;
    default:
      return ERROR_LEVELS.WARNING;
  }
};

export class ApiError<T> extends Error implements AxiosError<T> {
  isAxiosError = true;
  config: AxiosRequestConfig = {};
  code?: string;
  request?: any;
  response?: AxiosResponse<T>;
  toJSON = () =>
    ({
      name: this.name,
      message: this.message,
      config: this.config,
      code: this.code,
      request: this.request,
      response: this.response,
      isAxiosError: this.isAxiosError,
    }) as any;

  constructor(
    error: AxiosError<T>,
    message?: string,
    exception?: (errorCode: string | undefined) => string,
  ) {
    super(message ?? error.message);
    const errorStatus = error.response?.status;
    const errorCode = (error.response?.data as { code?: string })?.code;
    let name = 'ApiError';
    switch (errorStatus) {
      case RESPONSE_STATUS.BAD_REQUEST: // 400
        name = exception ? exception(errorCode) : 'ApiBadRequestError';
        break;
      case RESPONSE_STATUS.UNAUTHORIZED: // 401
        name = 'ApiUnauthorizedError';
        break;
      case RESPONSE_STATUS.FORBIDDEN: // 403
        name = 'ApiForbiddenError';
        break;
      case RESPONSE_STATUS.NOT_FOUND: // 404
        name = 'ApiNotFoundError';
        break;
      case RESPONSE_STATUS.INTERNAL_SERVER_ERROR: // 500
        name = 'ApiInternalServerError';
        break;
    }
    this.name = name;
    this.config = error.config;
    this.code = error.code;
    this.request = error.request;
    this.response = error.response;
    this.isAxiosError = error.isAxiosError;
    this.toJSON = error.toJSON;
  }
}
